import React, { useState } from "react";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";

const LoginPage = () => {
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");

  const handleLogin = async (e) => {
    e.preventDefault();
    setErrorMsg("");
    setLoading(true);

    try {
      const response = await fetch("http://localhost:3000/api/auth/login", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password }),
      });

      const data = await response.json();

      if (!response.ok) {
        setErrorMsg(data.message || "Wrong Email or password !");
        setLoading(false);
        return;
      }

      // Simpan student
      localStorage.setItem("student", JSON.stringify(data.student));

      // Ambil current_step dari backend
      const step = data.studentDemography?.current_step;

      // === REDIRECT LOGIC ===
      if (!step || step === "" || step === null) {
        navigate("/step1");
        return;
      }

      if (step === "done") {
        //navigate("/dashboard");
		navigate("/appreciate");
		
        return;
      }

      if (step === "10") {
        navigate("/appreciate");
        return;
      }

      navigate(`/step${step}`);

    } catch (error) {
      console.error("Sign-in error:", error);
      setErrorMsg("Cannot connect to server");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gradient-to-b from-blue-800 via-blue-700 to-blue-500 px-4">
      <motion.div
        className="bg-white/10 backdrop-blur-md border border-blue-200/30 rounded-2xl shadow-2xl p-8 w-full max-w-md"
        initial={{ opacity: 0, y: -40 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >

        {/* Logo */}
        <div className="flex justify-center mb-4">
          <img src="/images/logo-ut.png" alt="Logo UT" className="w-16 h-16 opacity-90" />
        </div>

        {/* Title */}
        <motion.h2
          className="text-3xl font-bold text-center text-yellow-300 mb-6"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.2 }}
        >
          Edupath Sign-in
        </motion.h2>

        {/* Error message */}
        {errorMsg && (
          <motion.div
            className="bg-red-100/80 text-red-800 p-3 mb-4 rounded-lg text-center text-sm font-medium"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
          >
            {errorMsg}
          </motion.div>
        )}

        {/* Form */}
        <form onSubmit={handleLogin} className="space-y-6">
          {/* Email */}
          <div>
            <label className="block text-gray-100 font-medium mb-2">Email</label>
            <input
              type="email"
              placeholder="0123456789@ecampus.ut.ac.id"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full bg-white/10 border border-blue-200/20 rounded-lg px-4 py-2 text-white placeholder-gray-300 focus:ring-2 focus:ring-yellow-300 focus:outline-none transition"
              required
            />
          </div>

          {/* Password */}
          <div>
            <label className="block text-gray-100 font-medium mb-2">Password</label>
            <div className="relative">
              <input
                type={showPassword ? "text" : "password"}
                placeholder="Your password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full bg-white/10 border border-blue-200/20 rounded-lg px-4 py-2 pr-10 text-white placeholder-gray-300 focus:ring-2 focus:ring-yellow-300 focus:outline-none transition"
                required
              />
              <button
                type="button"
                onClick={() => setShowPassword(!showPassword)}
                className="absolute right-3 top-2.5 text-yellow-300 hover:text-white transition"
              >
                {showPassword ? "🙈" : "👁️"}
              </button>
            </div>
          </div>

          {/* Submit */}
          <motion.button
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.97 }}
            type="submit"
            disabled={loading}
            className={`w-full ${
              loading ? "bg-gray-400" : "bg-yellow-400 hover:bg-yellow-300"
            } text-blue-900 py-3 rounded-lg font-bold shadow-md transition-all duration-300`}
          >
            {loading ? "Signing in..." : "SIGN-IN"}
          </motion.button>
        </form>

        <p className="text-center text-gray-100 text-sm mt-6">
          © {new Date().getFullYear()} Universitas Terbuka
        </p>
      </motion.div>
    </div>
  );
};

export default LoginPage;
